import { render, staticRenderFns } from "./checkStudyBehaviorRecord.vue?vue&type=template&id=348f68c2&scoped=true&"
import script from "./checkStudyBehaviorRecord.vue?vue&type=script&lang=js&"
export * from "./checkStudyBehaviorRecord.vue?vue&type=script&lang=js&"
import style0 from "./checkStudyBehaviorRecord.vue?vue&type=style&index=0&id=348f68c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f68c2",
  null
  
)

export default component.exports